import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      className="relative py-32 md:py-40 px-6 md:px-12 lg:px-24
      bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
      overflow-hidden"
    >
      {/* subtle grid overlay */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-20"></div>

      {/* brand glow */}
      <div className="absolute inset-x-0 top-1/3 h-[420px] bg-[#0E6F7E]/20 blur-3xl"></div>

      <div className="container mx-auto text-center relative z-10">
        <div className="max-w-4xl mx-auto space-y-10">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
            Build Stronger{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#1DBF73] to-[#D4AF37]">
              Capital Relationships
            </span>
          </h2>

          <p className="text-2xl md:text-3xl text-gray-200 font-light max-w-3xl mx-auto">
            Move beyond transactions. Build institutional-grade partnerships.
          </p>

          {/* CTA Button */}
          <div className="pt-12">
            <a
              href="https://forms.gle/yS12N6YnnmRH8rG37"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <button
                className="group px-14 py-5
                bg-gradient-to-r from-[#D4AF37] via-[#F4E4A6] to-[#C9A631]
                text-[#07162E] font-bold text-xl
                rounded-full
                shadow-[0_0_30px_rgba(212,175,55,0.45)]
                hover:shadow-[0_0_55px_rgba(212,175,55,0.7)]
                transition-all duration-300
                transform hover:-translate-y-2 hover:scale-[1.05]
                flex items-center gap-3 mx-auto
                animate-blink"
              >
                Apply for the Partner Program
                <ArrowRight className="w-6 h-6 group-hover:translate-x-2 transition-transform" />
              </button>
            </a>
          </div>

          <p className="text-gray-300 text-lg pt-8">
            Limited seats available. Applications are reviewed on a rolling
            basis.
          </p>
        </div>
      </div>

      {/* Blink animation */}
      <style>{`
        @keyframes blinkGlow {
          0%, 100% {
            box-shadow: 0 0 28px rgba(212,175,55,0.35);
          }
          50% {
            box-shadow: 0 0 60px rgba(212,175,55,0.75);
          }
        }
        .animate-blink {
          animation: blinkGlow 2.4s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}
